var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.startOfLoop)?_c('div',{staticClass:"loop-upper-node"},[_c('LoopSvg'),_c('div',[_vm._v("Loop")])],1):_c('div',{staticClass:"loop-lower-node"},[_vm._v("Loop End")])
}
var staticRenderFns = []

export { render, staticRenderFns }